import React from "react";
import { useRouter } from "next/router";

import {
  SectionIcon,
  SectionIconWrapper,
  SectionTitle,
  SectionWrapper,
} from "./style";

const SectionItem = ({ title, url }) => {
  const history = useRouter();
  return (
    <SectionWrapper onClick={() => history.push(`/faqs/${url}/`)}>
      <SectionIconWrapper>
        <SectionIcon icon="icon-caret-right" />
      </SectionIconWrapper>
      <SectionTitle variant="label1">{title}</SectionTitle>
    </SectionWrapper>
  );
};

export default SectionItem;
